export type StageName =
  | 'local'
  | 'dev'
  | 'stage'
  | 'prod'
  | 'pg-perm'
  | 'kk-perm';

/**
 * Environment config
 *
 * Для определения нового параметра конфига нужно добавить новое свойство
 * в данный объект. Значения для разных сред будет сформировано из значений
 * переменных окружения конкретного стенда на этапе сборки.
 */
export const environmentConfig = {
  STAGE: 'dev' as StageName,
  AWS_REGION: 'eu-central-1',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCp6cOqjYptNXiXLRRskl5jrh9dc5B2W3Q',
  CABINET_API: 'https://dev-cabinet.api.alivewater.online',
  TG_API: 'https://dev-tg.api.alivewater.online',
  HWT_API: 'https://web-dev.api.alivewater.cloud',
  MIGRATOR_API: '',
  KEYCLOAK_AUTH: '',
  npm_package_version: 'local',
  DADATA_TOKEN: 'd3c4dfe0047b071598fe42d9e3b838e161e89e49',

  PROXY: 'https://cabinet-gw.api.alivewater.cloud',
  KZ_PROXY: 'https://kz-cabinet-gw.api.alivewater.cloud',
  KZ_BILLING_URL: 'https://kz-payment.api.alivewater.cloud',
  OMNI_WIDGET: '15913-ccjh7bvb'
};

export type Config = Partial<typeof environmentConfig>;

export function isProductionStage(stage: string): boolean {
  return stage === 'prod' || stage === 'pg-perm' || stage === 'kk-perm';
}
